export const EquipmentName = 'equipmentComponent';
